<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row class="mt-5">
            <v-col>
                <v-card color="indigo lighten-4">
                    <v-toolbar color="indigo" dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                        <v-toolbar-title>アカウント情報</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(dbUser.id)"><h3>編集</h3></v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <h4>【ログインID】{{ dbUser.loginid }}</h4>
                        <h4>【ユーザ名】{{ dbUser.name }}</h4>
                        <h4>【メールアドレス】{{ dbUser.email }}</h4>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgUser.loginid }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field label="ユーザ名" v-model="dlgUser.name" outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field label="メールアドレス" v-model="dlgUser.email" outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
export default {
    name: "User",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            dbUser: {},
            dlgUser: {},
            showEditDlg: false,
            isLoading: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Logout" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Logout" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        await this.axiosGetUser();
        await new Promise((r) => setTimeout(r, 500));
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    methods: {
        //===================================================
        async axiosGetUser() {
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                params: {
                    _fields: "id,name,loginid,email",
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                if (response.data.json.length == 1) {
                    this.dbUser = response.data.json[0];
                }
            });
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            if (primaryKey == this.dbUser.id) this.dlgUser = JSON.parse(JSON.stringify(this.dbUser));
            this.showEditDlg = true;
        },
        //===================================================
        // サブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgUser["name"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            let axiosData = {
                name: this.dlgUser["name"],
                email: this.dlgUser["email"],
            };
            //-----------------------------------
            await this.axios({
                method: "PUT",
                url: "/web/api/users/" + this.dlgUser.id,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            }).then(() => {
                this.axiosGetUser();
            });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 100));
            this.isLoading = false;
        },
        //===================================================
    },
};
</script>
